import { Measurement } from '@design-stack-ct/utility-core';
import { produce } from 'immer';
import { isUnreplacedPlaceholderImage } from '../typeguards';
const PLACEHOLDER_METADATA_VERSION = '2';
function constructPlaceholderData(data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { item, index } = data;
    return {
        x: new Measurement(item.position.x).value,
        y: new Measurement(item.position.y).value,
        width: new Measurement(item.position.width).value,
        height: new Measurement(item.position.height).value,
        rotationAngle: parseFloat((_a = item.rotationAngle) !== null && _a !== void 0 ? _a : '0') || 0,
        crop: {
            top: (_c = (_b = item.cropFractions) === null || _b === void 0 ? void 0 : _b.top) !== null && _c !== void 0 ? _c : '0',
            right: (_e = (_d = item.cropFractions) === null || _d === void 0 ? void 0 : _d.right) !== null && _e !== void 0 ? _e : '0',
            bottom: (_g = (_f = item.cropFractions) === null || _f === void 0 ? void 0 : _f.bottom) !== null && _g !== void 0 ? _g : '0',
            left: (_j = (_h = item.cropFractions) === null || _h === void 0 ? void 0 : _h.left) !== null && _j !== void 0 ? _j : '0',
        },
        zIndex: item.zIndex,
        uploadUrlIndex: index,
        id: item.id,
    };
}
export function addPlaceholderMetadataToCimDoc(cimDoc) {
    var _a, _b, _c, _d, _e;
    // find all placeholder images based on template data
    const placeholderImageIds = ((_c = (_b = (_a = cimDoc.metadata) === null || _a === void 0 ? void 0 : _a.template) === null || _b === void 0 ? void 0 : _b.filter(isUnreplacedPlaceholderImage)) !== null && _c !== void 0 ? _c : []).map((imageTemplate) => imageTemplate.id);
    const placeholderMetadata = {
        version: PLACEHOLDER_METADATA_VERSION,
        uploads: [],
        canvases: [],
    };
    let uploadsIndex = 0;
    for (const panel of cimDoc.document.panels) {
        const imageItems = (_e = (_d = panel.images) === null || _d === void 0 ? void 0 : _d.filter((imageItem) => placeholderImageIds.includes(imageItem.id))) !== null && _e !== void 0 ? _e : [];
        if (imageItems.length === 0) {
            // put `null` when the panel has no placeholder images
            placeholderMetadata.canvases.push(null);
        }
        else {
            const canvasDataItems = [];
            for (const imageItem of imageItems) {
                // placeholders are going to have a preview url
                placeholderMetadata.uploads.push(imageItem.previewUrl);
                canvasDataItems.push(constructPlaceholderData({ item: imageItem, index: uploadsIndex }));
                uploadsIndex += 1;
            }
            placeholderMetadata.canvases.push(canvasDataItems);
        }
    }
    // update CimDoc with new metadata
    return produce(cimDoc, (draft) => {
        // reassigning is expected behavior when using immer
        // eslint-disable-next-line no-param-reassign
        draft.metadata = Object.assign(Object.assign({}, draft.metadata), { placeholders: placeholderMetadata });
    });
}
//# sourceMappingURL=placeholderExtraction.js.map